const configSystem = require("../../configApp");
const { logOut } = require("../../helpers/api");
const {
  faLayerGroup,
  faUsers,
  faChartColumn,
  faSliders,
  faGlobe,
  faClockRotateLeft,
  faBan,
  faStore,
  faLaptop,
  faIdCard,
  faArrowRightFromBracket,
  faGift,
  faHeartPulse,
} = require("@fortawesome/free-solid-svg-icons");

exports.config = {
  main: [
    { text: "Applications", to: "/applications", icon: faLayerGroup },
    {
      // Proxy residencial de Mitchell (ProDemand/TruckSeries). El dueno y Walter:
      // cambian IP/puerto/usuario/clave y las cuentas, y reinician los gateways.
      text: "Mitchell Proxy",
      to: "/mitchell-proxy",
      icon: faGlobe,
      users: ["admin@kaizenteks.com", "walter@gmail.com"],
    },
    {
      text: "User Management",
      to: "/user-management",
      icon: faUsers,
      roles: [configSystem.roles.ADMIN, configSystem.roles.SUPER_USER, configSystem.roles.SUPER_ADMIN],
    },
    {
      // Solo quien ve a otros admins: un admin limitado no tiene a quien resumir.
      text: "Admins",
      to: "/admins-summary",
      icon: faChartColumn,
      roles: [configSystem.roles.SUPER_USER, configSystem.roles.SUPER_ADMIN],
    },
    {
      text: "Applications Settings",
      to: "/applications-settings",
      icon: faSliders,
      roles: [configSystem.roles.ADMIN, configSystem.roles.SUPER_USER, configSystem.roles.SUPER_ADMIN],
    },
    {
      text: "Domain Management",
      to: "/domain-management",
      icon: faGlobe,
      roles: [configSystem.roles.ADMIN, configSystem.roles.SUPER_USER, configSystem.roles.SUPER_ADMIN],
    },
    {
      text: "Access History",
      to: "/access-history",
      icon: faClockRotateLeft,
      roles: [configSystem.roles.ADMIN, configSystem.roles.SUPER_USER, configSystem.roles.SUPER_ADMIN],
    },
    {
      // SOLO Super Admin. Ningun otro administrador puede dejar fuera a nadie.
      text: "IP Blocking",
      to: "/ip-blocking",
      icon: faBan,
      roles: [configSystem.roles.SUPER_ADMIN],
    },
    { text: "My Devices", to: "/my-devices", icon: faLaptop },
    { text: "My Account", to: "/my-account", icon: faIdCard },
    {
      // Registro de quien uso la prueba gratis de 1 hora. El servidor deja
      // verlo a Super Admin/Super User y a los de config.trial.verRegistro.
      text: "Trial Log",
      to: "/trial-log",
      icon: faGift,
      users: ["admin@kaizenteks.com", "walter@gmail.com"],
    },
    {
      // Vigilante de ALLDATA V2 / Identifix / ProDemand y botones para prestar
      // otra app a los clientes cuando una cae. Permiso real en el servidor.
      text: "App Status",
      to: "/app-status",
      icon: faHeartPulse,
      users: ["admin@kaizenteks.com", "walter@gmail.com"],
    },
  ],
  bottom: [{ text: "Log Out", action: logOut, icon: faArrowRightFromBracket }],
};
